var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3823",
    "data-name": "Rectangle 3823",
    width: 30,
    height: 30,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11334",
    "data-name": "Path 11334",
    d: "M27.048,24.079H16.237v-1.65a1.673,1.673,0,0,1,1.54-1.638c.652-.121,1.679-.4,1.679-1.044V18.673c0-.871-.635-1.356-1.673-2.042S15.7,15.264,15.7,13.845V3.61H27.585V13.845c0,1.419-1.108,2.146-2.083,2.787s-1.673,1.154-1.673,2.042v1.073c0,.64,1.027.923,1.638,1.033a1.7,1.7,0,0,1,1.581,1.65ZM17.39,22.925h8.5v-.5c0-.11,0-.392-.577-.508-2.279-.421-2.613-1.54-2.613-2.175V18.673c0-1.558,1.217-2.36,2.192-3.006s1.563-1.079,1.563-1.823V4.764H16.854v9.081c0,.744.577,1.154,1.563,1.823s2.192,1.448,2.192,3.006v1.073c0,.635-.335,1.731-2.585,2.169-.635.121-.635.4-.635.513Z",
    transform: "translate(-6.642 -1.527)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11335",
    "data-name": "Path 11335",
    d: "M13.38,14.529h-.629a1.667,1.667,0,0,1-1.154-.485l-.681-.663a2.712,2.712,0,0,1-.8-1.927V6.4h3.8V7.554H11.274v3.9a1.535,1.535,0,0,0,.462,1.108l.663.669a.5.5,0,0,0,.352.144h.629Z",
    transform: "translate(-4.282 -2.708)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11336",
    "data-name": "Path 11336",
    d: "M36.465,14.529h-.629V13.375h.629a.5.5,0,0,0,.352-.144l.663-.669a1.535,1.535,0,0,0,.462-1.108v-3.9H35.3V6.4h3.8v5.054a2.712,2.712,0,0,1-.8,1.927l-.669.663A1.667,1.667,0,0,1,36.465,14.529Z",
    transform: "translate(-14.935 -2.708)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11337",
    "data-name": "Path 11337",
    d: "M27.871,43.609H13.84V37.09H27.871ZM14.994,42.455H26.717V38.244H14.994Z",
    transform: "translate(-5.855 -15.692)",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinInactive);
export default __webpack_public_path__ + "static/media/winInactive.e97a1567c11243b650704da4358b8b75.svg";
export { ForwardRef as ReactComponent };